import React, { useEffect } from "react";
import { UserContext } from "../Definitions/UserContext";
import { BlogDetailsConsumer, GetBlogAuthors, GetBlogTagsOrCategories } from "../Utilities/BlogAPI";

import ReactDOM from "react-dom";



//function for mapping out proper name for authors, tags & categories based on their encId
export default async function BlogSync(context:UserContext){

    let authorDom = document.getElementById("blog-author-text");
    let profileImgDom = document.getElementById("author-profile-img");


    let dateDom = document.querySelector(".blog-date");

    if(dateDom&&dateDom.textContent){
        let date = new Date(dateDom.textContent+" UTC");
        const formattedDate = new Intl.DateTimeFormat("en-US", {
            month: "short",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          }).format(date);

        dateDom.textContent = formattedDate;
    }

    let chipRow = document.getElementById("blog-chip-row");
    // let promisArr:Promise<any>[] = [];

    const disableStencil = ()=>{
        let stenciled = document.querySelectorAll(".blog-header .stenciled");
        stenciled.forEach(stenciled=>{
            stenciled.classList.remove("stenciled");
        });
    }

    const onError = ()=>{
        if(chipRow){
            chipRow.remove();
        }

        if(authorDom){
            authorDom.textContent = "Uknown";
           
        }
        disableStencil();
        if(profileImgDom) profileImgDom.style.display = "none";
    }

    let slug = window.location.pathname.split("/").filter(t=>t.length>0&&t!="/").pop();

    if(slug){

        //get the details and set tags, category and author
        BlogDetailsConsumer(context,slug,(inData)=>{
            if(inData?.data?.data){
                 let data = inData.data.data;

                 let authorLink = (data.encAuthor&&data.author)?'blog-search/author/'+encodeURIComponent(data.author)+'/'+data.encAuthor:"";
                if(authorDom){
                    if(!data.author) // plain text anonymous
                    authorDom.textContent = "Anonymous";
                    else{
                        authorDom.textContent = "";
                        ReactDOM.render(<a href={authorLink}>{data.author}</a>,authorDom)
                    }
                }
              if(profileImgDom){
                if(data.photoURL){
                    profileImgDom.style.backgroundImage = `url(${data.photoURL})`;
                }
                else if(profileImgDom){
                    profileImgDom.textContent = data.spintials??"?";
                }
                if(data.encAuthor){
                    let a = document.createElement("a");
                    a.href = authorLink;
                    if(profileImgDom.before){ // edge case, check for browser compatiability with before, otherwise leave as is
                        profileImgDom.before(a);
                        a.appendChild(profileImgDom);
                    }
                }

            }
                if(chipRow){


                    chipRow.innerHTML = "";//clear the chip row


                    ReactDOM.render(<>
                    {
                        data.category.map((category:string,index:number)=>{
                            return <a href={`blog-search/category/${encodeURIComponent(category)}`} key={index} className="no-a blog-chip category">{category}</a>
                        })
                    }
                    {
                        data.tag.map((tag:string,index:number)=>{
                            return <a href={`blog-search/tag/${encodeURIComponent(tag)}`} key={index} className="no-a blog-chip tag">{tag}</a>
                        })

                    }
                    
                    </>,chipRow);

                }

                disableStencil();
            
      
            
            }
            
            else{
                onError();
            }
        },(data)=>{
            onError();
        });
    }



}



export const GetNameListFromChips = (selectedIds:string[],allChips:{id:string,name:string}[])=>{
    if(!selectedIds||selectedIds.length==0) return [];

    let list:string[] = [];
    selectedIds.forEach(id=>{
        let chip = allChips.find(t=>t.id==id);
        if(chip) list.push(chip.name);
        else{
            list.push("?");
        }
    });


    return list;

}
